<template>
	<div style="font-size: 16px; text-color: #000000">
		<div>
			Gavekortet blir tilgjengelig når kjøpet er fullført, og du kan alltid finne det igjen i din ordrehistorikk på Min side. Gavekortet skriver du ut, bretter to ganger og gir til en heldig mottaker.
		</div>
		<section>
			<v-row>
				<v-col cols="12">
					<img style="max-width: 100%; height: auto" :src="getPDFImageFromStore() || 'https://res.cloudinary.com/odin-systemer/image/upload/v1576162234/resources/misc/levering_pdf.png'" />
				</v-col>
			</v-row>
		</section>
	</div>
</template>

<script>
import { GiftCardPurchaseDetails } from '@/services/models';
export default {
	name: 'pdf-shipping',
	model: {
		prop: 'giftcard'
	},
	props: {
		giftcard: GiftCardPurchaseDetails
	},
	data() {
		return {
			valid: true
		};
	},
	methods: {
		getPDFImageFromStore() {
			return this.$store.state.giftcard.deliveryOptions.find(x => x.deliveryMethod == '3').PortraitImageUrl;
		}
	},
	watch: {
		valid: function(value) {
			this.$emit('onValidationChange', value);
		}
	},
	created() {
		this.$emit('onValidationChange', true);
	}
};
</script>

<style scoped></style>
